import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Company from "../../entity/user/Company";

const SERVICE = "service-user";
const ENTITY = "companies";

export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Company(data);

    return {
        findOneById(id, role = "entrepreneur") {
            return {
                select() {
                    const result = state(state => state.api?.user?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, role);
                }
            }
        },
        async update(id, property, payload) {
            update(SERVICE, ENTITY, id, property, payload, newInstance, "entrepreneur");
        }
    }
}